import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AssociatedContactType, BaseClient, ClientType } from '@models/clients';
import { ClientsDispatch } from '@state/clients';
import LogRocket from 'logrocket';
import {
	AssociatedContact,
	RemoveAssociation,
} from 'src/app/shared/atomic/organisms/associated-card/associated-card.types';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';
import {
	AssociationModalComponent,
	EditAssociationModalData,
	EditAssociationModalResponse,
} from '../association-modal/association-modal.component';
import { catchError, filter, first, switchMap } from 'rxjs/operators';
import { ClientCreationService } from '@services/closer-api/client-creation/client-creation.service';
import { TestHooks } from './association.hooks';

@Component({
	selector: 'app-association',
	templateUrl: './association.component.html',
	styleUrls: ['./association.component.scss'],
	standalone: false,
})
export class AssociationComponent {
	testHooks = TestHooks;
	public client: BaseClient;
	public clientTypes = ClientType;
	public _association: AssociatedContact;
	public url: string;

	@Input() parentClientId: string;
	@Input() set association(association: AssociatedContact) {
		this._association = association;
		this.client = association?.clientInfo;
	}

	constructor(
		private snackBar: SnackbarService,
		private dialogComponent: MatDialog,
		private clientDispatch: ClientsDispatch,
		private clientCreationService: ClientCreationService,
	) {}

	deleteClientAssociation(): void {
		this.clientCreationService
			.RemoveAllAssociations({
				parentClientId: this.parentClientId,
				childClientId: this.client.id,
			})
			.toPromise();
	}

	removeAssociations(associations: RemoveAssociation[]): void {
		this.clientCreationService
			.RemoveAssociation({
				associatedContactType: associations[0].associationType,
				parentClientId: this.parentClientId,
				childClientId: associations[0].clientId,
			})
			.toPromise();
	}

	updatePrimaryContactStatus(ev: boolean): void {
		this.clientDispatch.SetAssociationPrimaryContactStatus(
			this.parentClientId,
			this.client.id,
			ev,
		);
	}

	editAssociation(data: EditAssociationModalData): void {
		this.dialogComponent
			.open<
				AssociationModalComponent,
				EditAssociationModalData,
				EditAssociationModalResponse
			>(AssociationModalComponent, {
				minWidth: '400px',
				data,
			})
			.afterClosed()
			.pipe(
				filter(
					(result) =>
						result?.clientId && this.parentClientId !== result.clientId,
				),
				switchMap((result) => {
					if (data.primaryContact !== result.primaryContact) {
						this.clientDispatch.SetAssociationPrimaryContactStatus(
							this.parentClientId,
							result.clientId,
							result.primaryContact,
						);
					}

					return this.clientCreationService.AddExistingClientToAssociation({
						associatedContactType: AssociatedContactType.SIGNING_OFFICER,
						childClientId: result.clientId,
						parentClientId: this.parentClientId,
						position: result.position ?? '',
					});
				}),
				first(),
				catchError((err) => {
					LogRocket.error(
						`Unable to edit associated contact of type ${AssociatedContactType.SIGNING_OFFICER} to client`,
						err,
					);
					this.snackBar.openSnackBar({
						text: `Unable to edit ${AssociatedContactType.SIGNING_OFFICER}`,
						type: 'error',
					});
					return null;
				}),
			)
			.toPromise();
	}
}
